/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */
import * as React from 'react';
import { ICittaInvDlvBannerViewProps } from './citta-inv-dlv-banner';
export default (props: ICittaInvDlvBannerViewProps) => {
    const { noStatus, allStatus, taxStatus, status, closeButton } = props;
    let bannertodisplay:React.ReactNode;
    if (status == 0) {
        bannertodisplay = noStatus;
    } else if (status == 1) {
        bannertodisplay = taxStatus;
    } else {
        bannertodisplay = allStatus;
    }
    if (status !=99) {
        return (
            <>
            <div className='invoicedeliverystatusbanner'>
                <div>
                    {bannertodisplay}
                </div>
                {closeButton}
            </div>
            </>
        );
    } else {
        return (
            <>
                <div></div> 
            </>
        );
    }
};
